import { appRoutes } from "@/app/router";
import { copyTextToClipboard } from "@/modules/clipboard/copyTextToClipboard";
import { toastModule } from "@/modules/toast";
import { windowModule } from "@/modules/window";

export const copyCollectionLinkToClipboard = async ({ collectionId }: { collectionId: string }) => {
  const targetUrl = windowModule.buildUrl({
    path: appRoutes.collectionsView({ params: { collectionId } }).path,
  });

  await copyTextToClipboard({
    text: targetUrl.toString(),
  });

  toastModule.triggerToast({ content: "Link copied to clipboard" });
};
